
/*
 * Filename: iva-calculator-module.js
 * By: J. Nguyen  
 * Date: 4/18/23
 *
 * Description: 
 * This will house the functionality for the IVA calculator panel.
 *
 */

import Tooltip from '../modules/tooltip'; 

export default function IvaCalcModule(element, optionOverwrites) {

  const elem = element;                       // remember the parent element
  let api = {};                               // Object to contain the publicly accessible functions

  // default options
  const defaults = {
    debugMode: false,
    baselineSavings: .35
  };

  // overwrite options based on optionOverwrites
  const options = Object.assign(defaults, optionOverwrites);
  const tooltipOptions = {};
  
  // DOM NODES
  const selectNodes = elem.getElementsByClassName('iva-calculator__select');
  const displayResults = elem.getElementsByClassName('iva-calculator__net-savings');
  const netSavingsNode = displayResults[0];
  const netSavingsPerCallNode = displayResults[1];

  // DATA VARIABLES - private variables
  let netSavings = 0;
  let netSavingsPerCall = 0;

  // Create number formatter.
  const dollarFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0, 
    minimumFractionDigits: 0
  });

  const dollarWithCentsFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2, 
    minimumFractionDigits: 2
  });

  init();

  // initilize the module
  function init() {
    debug('insider IvaCalcModule init()');

    // Tooltip functionality initialization
    Tooltip(elem, tooltipOptions);
    
    // Setup event handlers
    for (let x = 0; x < selectNodes.length; x++){
      selectNodes[x].addEventListener("change", calculateSavings);
    }
  }


  // HELPER FUNCTIONS
  //===============================================
  
  // Basic debug function
  function debug(msg) { 
    if (defaults.debugMode) {
      console.log(msg);
    }
  }

  
  // PUBLIC FUNCTIONS
  //===============================================
 
  // This function will update the results displays
  // It takes two params that correspond to the net savings and call volume respectively.
  function updateResults(netSavings, callVolume) {
    debug("updateResults()");

    debug('netSavings: ' + netSavings);
    debug('callVolume: ' + callVolume);
    debug('netSavingsNode.textContent: ' + dollarFormatter.format(netSavings));
    debug('netSavingsPerCallNode.textContent: ' + dollarWithCentsFormatter.format( netSavings / callVolume ));

    netSavingsPerCallNode.textContent = dollarWithCentsFormatter.format( netSavings / callVolume );

    // round savings to nearest 1000's
    netSavings = Math.round(netSavings/1000)*1000;
    netSavingsNode.textContent = dollarFormatter.format(netSavings);
   
  }

  // This function will calculate the savings and 
  // update the results fields. Assumption that selectNodes[0] = call volume value
  function calculateSavings(event) {
    debug("calculateSavings()");  

    let exitFlag = 0;
    let callVolume = 0;
    let productValue = options.baselineSavings;

    debug('product before: ' + productValue);

    for (let x = 0; x < selectNodes.length; x++){
      // exit case if not all select values are chosen
      if (selectNodes[x].value === ""){
        exitFlag = 1;
        break;
      } else {

        // store call volume for later use and begin the computing product of values
        if (x == 0) {
          callVolume = selectNodes[x].value;
          productValue = callVolume * productValue;
          debug('updated product after: ' + productValue);

        } else {
          debug('new value to multiply: ' + selectNodes[x].value);
          productValue = selectNodes[x].value * productValue;
          debug('updated product after: ' + productValue);
        }

      }
    }

    if (exitFlag != 1) {
      updateResults(productValue, callVolume);
    }

    debug('callVolume: ' + callVolume);
  }
  
  
  // EXPOSE PUBLIC FUNCTIONS VIA THE API
  // Map all the functions we want to expose for public access
  //===============================================================
  api.calculateSavings = calculateSavings;
  api.updateResults = updateResults;
  return api;

}
